export const environment = {
  production: false,
  isMockEnabled: true,
  storageKey: "12353513153CDCD313D1C3",
  // apiUrl: "https://api.tozamakon.eco/",
  apiUrl: "https://tozamakon-dev-api.xdevs.uz/",
  stadiaApiKey: "3e2e3471-58a3-4d6e-b168-cf38661a9423",
};
